"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HashReference = void 0;
class HashReference {
    constructor(hash, className) {
        this.hash = hash;
        this.className = className;
    }
    //static create(target: T) {
    //   return new HashReference<T>(target.hash(), target.getClassName());
    //}
    literalize() {
        return { _type: 'hashed_object_reference', _hash: this.hash, _class: this.className };
    }
    static deliteralize(literal) {
        return new HashReference(literal._hash, literal._class);
    }
    static hashFromLiteral(literal) {
        return literal._hash;
    }
    static classNameFromLiteral(literal) {
        return literal._class;
    }
}
exports.HashReference = HashReference;
//# sourceMappingURL=HashReference.js.map